import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { faCheckSquare } from '@fortawesome/pro-regular-svg-icons/faCheckSquare';
import { faSquare } from '@fortawesome/pro-regular-svg-icons/faSquare';
import { faMinusSquare } from '@fortawesome/pro-regular-svg-icons/faMinusSquare';

import withComponentName from '../../../../../../decorators/withComponentName';

const DropdownRow = ({
  showRightArrow,
  showArrow,
  isRightSideMenuOpen,
  isSelectAll,
  categoryId,
  id,
  name,
  select,
  handleRowSelect,
  handleExpandRowSelect,
}) => {
  const handleExpandSelect = (e) => {
    const value = {
      id,
      name,
    };
    handleExpandRowSelect(e, value, isRightSideMenuOpen);
  };

  const handleSelect = () => {
    const value = {
      id,
      name,
    };
    if (showRightArrow && showArrow) {
      return handleRowSelect(value, isSelectAll);
    }
    if (showRightArrow) {
      value.isSelectAll = true;
      return handleRowSelect(value, isSelectAll);
    }
    if (categoryId) {
      value.category_id = categoryId;
    }
    return handleRowSelect(value, select);
  };

  return (
    <Dropdown.Item
      eventKey={id}
      active={isSelectAll || select || isRightSideMenuOpen}
      onSelect={handleSelect}
      bsPrefix={`dropdown-item ${isRightSideMenuOpen ? 'right-side-open' : ''}`}
    >
      <div>
        <LeftSideBox
          showRightArrow={showRightArrow}
          isSelectAll={isSelectAll}
          select={select}
        />
      </div>
      <span className="dropdown__checkbox_title">{name}</span>
      {
        showRightArrow && showArrow
          ? (
            <div className="dropdown__checkbox_right" onClick={handleExpandSelect}>
              <FontAwesomeIcon icon={isRightSideMenuOpen ? faChevronLeft : faChevronRight} />
            </div>
          ) : null
      }
    </Dropdown.Item>
  );
};

const LeftSideBox = ({ showRightArrow, isSelectAll, select }) => {
  if (isSelectAll) return <FontAwesomeIcon icon={faCheckSquare} />;

  if (select) {
    if (showRightArrow && !isSelectAll) return <FontAwesomeIcon icon={faMinusSquare} />;
    return <FontAwesomeIcon icon={faCheckSquare} />;
  }
  return <FontAwesomeIcon icon={faSquare} />;
};

export default withComponentName(DropdownRow);
